import axiosClient from '../../../config/api/axios.js'
import { parseChatError } from './parseChatError.js'

export async function uploadThreadSources({ threadId, files, signal }) {
  if (!threadId) {
    return { ok: false, code: 'NO_THREAD', message: 'A chat thread is required before uploading files.' }
  }
  const selected = Array.isArray(files) ? files.filter(Boolean) : []
  if (!selected.length) return { ok: true, sources: [], sourceIds: [] }

  const form = new FormData()
  selected.forEach((file) => form.append('files', file))
  try {
    const { data } = await axiosClient.post(`/api/threads/${encodeURIComponent(threadId)}/sources`, form, {
      signal,
    })
    const sources = Array.isArray(data?.sources) ? data.sources : []
    return {
      ok: true,
      sources,
      sourceIds: sources.map((source) => source.id).filter(Boolean),
    }
  } catch (err) {
    return parseChatError(err)
  }
}
